import type { ThemeComponentsInterface } from '~/types/AppData/Theme/ThemeComponentsInterface';
import type { LayoutInterface } from '~/types/AppData/LayoutInterface';

export const getHeaderHeight = (
  theme: ThemeComponentsInterface,
  layout: LayoutInterface,
  opt?: {
    add?: number;
    screenSize?: 'Large' | 'Medium' | 'Small';
    include?: Array<'firstRow' | 'secondRow'>;
    isSI?: boolean;
  }
) => {
  // Get the height of the header sections and then add to it
  let height = 0;

  // Defaults
  const defaults = {
    add: 0,
    screenSize: 'Large',
    include: ['firstRow', 'secondRow'],
    isSI: false,
  };

  const options = Object.assign(defaults, opt);

  let firstRowHeight =
    theme.header[`firstRowHeightIn${options.screenSize}Screen`].value * 20;

  // TODO: Remove this once SI sites have a value for firstRowHeight
  // Hardcode a value for SI first row height since this isn't set on onSI sites
  if (!firstRowHeight && options.isSI) {
    firstRowHeight = 3.85 * 20;
  }

  // First header height
  if (
    layout.header.links?.value &&
    layout.header.links.value.length &&
    options.include.includes('firstRow')
  ) {
    height += firstRowHeight;
  }

  if (
    options.include.includes('secondRow') &&
    !layout.header.secondaryLogo?.value &&
    (layout.subHeader?.links?.value.length ||
      layout.subHeader?.socialLinks?.value.length)
  ) {
    height +=
      theme.header[`secondRowHeightIn${options.screenSize}Screen`].value * 20;
  }

  height += options.add;

  return `${height}px`;
};
